import { Ref, ref } from "vue";
/**
 * Hook pour manipuler un nombre réactif.
 *
 * @param number Valeur initiale (number)
 * @returns { refNumber, doChangeNumber }
 */
function useNumber(number: number = 0) {
  const refNumber: Ref<number> = ref(number);

  const doChangeNumber = function (newNumber: number) {
    refNumber.value = newNumber;
  };

  return {
    refNumber,
    doChangeNumber,
  };
}

export default useNumber;
